import React from "react";
import { Button } from "../../../components";

const tabs = [
    "Overview",
    "Timeline",
    "Top Performers",
    "Influencers",
    "Content",
];

/**
 * AnalyticsTabs - Sticky tab navigation bar for analytics sections
 * @param {string} activeTab - Currently active tab name
 * @param {function} onTabClick - Callback when a tab is clicked
 * @param {function} onManageSectionClick - Callback when Manage Section button is clicked
 */
const AnalyticsTabs = ({ activeTab, onTabClick, onManageSectionClick, sectionVisibility, campaignType, showManageButton = true, isPdfView, visibleTabs: visibleTabsProp }) => {
    const visibleTabs = visibleTabsProp || tabs.filter(tab => {
        // Filter for UGC campaigns
        if (campaignType === "content") {
            if (tab === "Overview" || tab === "Top Performers") return false;
        }

        const key =
            tab === "Top Performers" ? "topPerformers" : tab.toLowerCase();

        // Always show Overview for non-UGC campaigns
        if (campaignType !== "content" && key === "overview") {
            return true;
        }

        return sectionVisibility?.[key] !== false; // Default to true if undefined
    });

    if (isPdfView) return null;

    return (
        <div
            className="tabs-sticky-bar"
            style={
                !showManageButton
                    ? { top: "68px" } // Shared analytics view - below shared header only
                    : undefined // Campaign analytics view - uses CSS positioning
            }
        >
            <div className="tabs">
                {visibleTabs.map((tab) => (
                    <button
                        key={tab}
                        className={`tab ${activeTab === tab ? "active" : ""}`}
                        onClick={() => onTabClick(tab)}
                    >
                        {tab}
                    </button>
                ))}
            </div>
            {showManageButton && (
                <Button variant="secondary" onClick={onManageSectionClick}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <div className="three-lines-icon">
                            <div className="line-1"></div>
                            <div className="line-2"></div>
                            <div className="line-3"></div>
                        </div>
                        Manage Section
                    </div>
                </Button>
                // <button className="manage-section-btn" onClick={onManageSectionClick}>
                //     <div className="three-lines-icon">
                //         <div className="line-1"></div>
                //         <div className="line-2"></div>
                //         <div className="line-3"></div>
                //     </div>
                //     Manage Section
                // </button>
            )}
        </div>
    );
};

export default AnalyticsTabs;
